import { handleActions } from 'redux-actions';
import * as actions from './actions';

const defaultState = {
  showProcessingLoader: false,
  showGeneratingLoader: false,
  generatingLoaderProgress: null,
  showStarterLoader: true,
  showGoAppModal: false,
};

const reducer = handleActions(
  new Map([
    [actions.setProcessingLoaderVisibility,
      (state, action) => {
        return { ...state, showProcessingLoader: action.payload };
      }],
    [actions.setGeneratingLoaderVisibility,
      (state, action) => {
        return { ...state, showGeneratingLoader: action.payload };
      }],
    [actions.setGeneratingLoaderProgress,
      (state, action) => {
        return { ...state, generatingLoaderProgress: action.payload };
      }],
    [actions.setStarterLoaderVisibility,
      (state, action) => {
        return { ...state, showStarterLoader: action.payload };
      }],
    [actions.setGoAppModalVisibility,
      (state, action) => {
        return { ...state, showGoAppModal: action.payload };
      }],
    [actions.setSidebarVisibility,
      (state, action) => {
        return { ...state, showSidebar: action.payload };
      }],
  ]),
  defaultState
);

export default reducer;